import {IconProps} from './types';

/* A perforated ticket struck through — the "sold out" mark on a series event */
const SoldOut = ({fill = 'currentColor', className, width = 24, height = 16}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 16"
        fill="none"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <rect x="2" y="2.5" width="20" height="11" rx="2" />
        <path d="M12 2.5v2M12 11.5v2" />
        <line x1="5.5" y1="12.5" x2="18.5" y2="3.5" />
    </svg>
);

export default SoldOut;
